<tr>
    <ng-template #fieldComponent></ng-template>
</tr>